export const textFieldStyleOverride = {
    MuiTextField: {
        defaultProps: {
            size: "small",
        },
    },
};
